"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CALL_API = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // property assigned to API calls so that the middleware can identify them


var CALL_API = 'Call API';
/**
 * A function that accepts an auth manager instance, and returns a redux API Middleware that will
 * pass API calls through the authGuard, allowing for re-authentication and retry of request when 401
 * requests are received
 */

exports.CALL_API = CALL_API;

var _default = function _default(authManager) {
  return (// return redux middleware
    function () {
      return function (next) {
        return function (action) {
          // get the `CALL_API` property on the action
          var apiCall = _lodash.default.get(action, CALL_API); // if undefined, it's not an api call, so pass it to the next() middleware


          if (_lodash.default.isUndefined(apiCall)) {
            return next(action);
          } // else, it is an API call, so we destructure the properties we need


          var _apiCall$types = _slicedToArray(apiCall.types, 3),
              requestType = _apiCall$types[0],
              successType = _apiCall$types[1],
              failureType = _apiCall$types[2],
              request = apiCall.request,
              misc = apiCall.misc,
              callback = apiCall.callback,
              errorCallback = apiCall.errorCallback; // dispatch the "_REQUEST" action


          next({
            type: requestType,
            misc: misc
          }); // handler for when the API call succeeds

          var handleSuccess = function handleSuccess(response) {
            // we dispatch the _SUCCESS type, with the response and misc data
            next({
              type: successType,
              response: response || {},
              misc: misc
            }); // if a callback was provided, we pass it the data

            if (callback) callback(response);
          }; // handler for when the api API call fails


          var handleError = function handleError(error) {
            // we dispatch the _FAILURE type, with the response and misc data
            next({
              type: failureType,
              response: _lodash.default.get(error, ['response', 'data'], {}),
              misc: misc
            });
            if (errorCallback) errorCallback(error);
          }; // use authGuard to execute the request


          authManager.authGuard(request, handleSuccess, handleError);
        };
      };
    }
  );
};

exports.default = _default;